<script setup lang="ts">
const { showBack = true } = defineProps<{
  /** Title text to display in the Header */
  title: string
  /** Optional subtitle text to display */
  subtitle?: string
  /** Optional class name for the container */
  containerClass?: string
  /** Whether to show the account manager card */
  showAccountManager?: boolean
  /** Whether to show the back button */
  showBack?: boolean
  /** Custom text to display instead of the default "back" */
  backContent?: string
  /** Custom redirect path instead of router.back() */
  customRedirect?: string
}>()
</script>

<template>
  <div class="flex flex-col gap-6 text-base-content pb-4 md:pb-8" :class="containerClass">
    <Back
      v-if="showBack"
      :back-content="backContent"
      :custom-redirect="customRedirect"
    />

    <div class="flex justify-between items-start">
      <div class="flex flex-col grow gap-2">
        <!-- Header slot with default fallback -->
        <slot name="header">
          <Header>
            {{ title }}
          </Header>
        </slot>

        <!-- Subtitle content -->
        <template v-if="subtitle">
          <Subtitle>
            {{ subtitle }}
          </Subtitle>
        </template>

        <!-- Custom subtitle slot if no subtitle prop provided -->
        <slot v-else name="subtitle" />

        <!-- Extra content slot below the subtitle -->
        <slot name="extra" />
      </div>

      <AccountManager
        v-if="showAccountManager"
        inline
        class="flex-shrink-0 ml-4"
      />
    </div>
  </div>
</template>
